import { CallState } from "redmond";
import { actions, actionTypes } from "../actions";
import { IPackagesBookState } from "./state";

const initialState: IPackagesBookState = {
  userPassengers: [],
  userPassengerCallState: CallState.NotCalled,
};

export function reducer(
  state: IPackagesBookState = initialState,
  action: actions.PackagesBookActions
): IPackagesBookState {
  switch (action.type) {
    case actionTypes.FETCH_USER_PASSENGERS:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };

    case actionTypes.UPDATE_USER_PASSENGER:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };

    case actionTypes.DELETE_USER_PASSENGER:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };

    case actionTypes.SET_USER_PASSENGERS:
      return {
        ...state,
        userPassengerCallState: CallState.Success,
        userPassengers: [...action.userPassengers],
      };
    case actionTypes.FETCH_CORP_USER_PASSENGERS:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };
    case actionTypes.SET_USER_PASSENGERS_CALL_STATE:
      return {
        ...state,
        userPassengerCallState: action.callState,
      };
    default:
      return state;
  }
}

export * from "./selectors";
